import type { ITicketFeature } from '@/shared/api/types/ticket-feature-types'

/** Resolves a display name for a ticket feature, falling back through other languages to the key. */
export function resolveTicketFeatureName(
  feature: Pick<ITicketFeature, 'featureKey' | 'localizedData'>,
  languageCode: string,
): string {
  const { localizedData, featureKey } = feature
  const preferred = localizedData[languageCode]
  const candidates = [
    preferred?.name,
    preferred?.description,
    ...Object.values(localizedData).map((value) => value?.name),
    ...Object.values(localizedData).map((value) => value?.description),
  ]
  return candidates.find((value) => value?.trim())?.trim() ?? featureKey
}
